import React from 'react';
import Page from 'src/components/Page';
import mediaPaths from 'src/mediaPaths';
import SpecLink from '../../SpecLink';

function BatchPage() {
    return <Page header="Batch">
        <p>
            Batches are used to process transactions in an asynchronous manner. CSV files (comma delimited) are submitted, and a background process will process them. You can then download the result of the batch operation to check its status.
        </p>
        <p>
            Typically, the order of operations would be:
        </p>
        <ol>
            <li><SpecLink uriFragment="#operation/Batch_UploadBatch">Submit batch</SpecLink> to upload batch file.</li>
            <li><SpecLink uriFragment="#operation/Batch_DownloadBatchResult">Download batch result</SpecLink> to check status of batch file processing.</li>
            <li><SpecLink uriFragment="#operation/Batch_SearchBatchStats">Search batch stats</SpecLink> returns a list of batches that have been processed.</li>
        </ol>
        <p>
            You can construct your batch files by following our <a href={mediaPaths.batchFileSpec} target="_blank" rel="noopener noreferrer">guide</a>.  You can find batch file samples towards the end of the spec.
        </p>
    </Page>
}

export default BatchPage;
